import { z } from 'zod';

export const deliveryPreferencesInstructionCodeValues: Array<DeliveryPreferencesInstructionCodeEnum> =
  [
    'front door',
    'side door',
    'rear door',
    'garage',
    'reception',
    'deck',
    'porch',
  ];

const deliveryPreferencesInstructionCodeEnum = z.enum([
  'front door',
  'side door',
  'rear door',
  'garage',
  'reception',
  'deck',
  'porch',
]);

const deliveryAddressSchema = z.object({
  street1: z.coerce.string(),
  street2: z.coerce.string().optional(),
  city: z.coerce.string(),
  state: z.coerce.string(),
  zipcode: z.coerce.string(),
  countryCode: z.coerce.string(),
});

export const deliveryAddressValidationSchema = z.object({
  street1: z.coerce.string().max(1000),
  street2: z.coerce.string().max(1000).optional(),
  city: z.coerce.string().max(200),
  state: z.coerce.string().max(200),
  zipcode: z.coerce.string().max(20),
  countryCode: z.coerce.string().max(10),
});

const deliveryInstructionsSchema = z.object({
  instructionCode: deliveryPreferencesInstructionCodeEnum,
  comment: z.coerce.string().optional(),
  pin: z.coerce.string().optional(),
});

const deliveryInstructionsValidationSchema = z.object({
  instructionCode: deliveryPreferencesInstructionCodeEnum,
  comment: z.coerce.string().max(2000).optional(),
  pin: z.coerce.string().optional(),
});

export const deliveryPreferencesSchema = z.array(
  z.object({
    deliveryAddress: deliveryAddressSchema,
    instruction: deliveryInstructionsSchema,
  }),
);

export const upsertDeliveryPreferencesSchema = z.array(
  z.object({
    deliveryAddress: deliveryAddressValidationSchema,
    instruction: deliveryInstructionsValidationSchema,
  }),
);

export type DeliveryAddress = z.infer<typeof deliveryAddressSchema>;
export type DeliveryPreferences = z.infer<typeof deliveryPreferencesSchema>;
export type DeliveryInstructions = z.infer<typeof deliveryInstructionsSchema>;
export type DeliveryPreferencesInstructionCodeEnum = z.infer<
  typeof deliveryPreferencesInstructionCodeEnum
>;
